import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StingrayCommonModule } from '@modules/common/common.module';
import { RefreshDataHeaderComponent } from '@modules/data-refresh-shared/components/refresh-data-header/refresh-data-header.component';

@NgModule({
    declarations: [
        RefreshDataHeaderComponent
    ],
    imports: [
        CommonModule,
        StingrayCommonModule
    ],
    exports: [
        RefreshDataHeaderComponent
    ]
})
export class DataRefreshSharedModule {
}
